<template>
	<el-row>
		<el-row :gutter="0">
			<el-col :span="6">
				<div class="search-view">
					<div>课件方向:</div>
					<el-select size="mini" class="margin-left-10" v-model="courseDirection" clearable placeholder="全部">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="search-view">
					<span style="padding-left: 30px;">课件类别:</span>
					<el-cascader size="mini" class="margin-left-10 input" v-model="courseCategory" :options="options2"
						:props="cateListProps" clearable placeholder="全部" />
				</div>
			</el-col>
			<el-col :span="8">
				<div class="search-view">
					<span>创建日期:</span>
					<el-date-picker size="mini" style="margin-left: 10px" format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss" v-model="time" type="datetimerange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" align="right">
					</el-date-picker>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="search-view">
					<div>订单状态:</div>
					<el-select size="mini" class="margin-left-10" v-model="status" clearable placeholder="全部">
						<el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="0">
			<el-col :span="6">
				<div class="search-view">
					<div>订单号:</div>
					<el-input size="mini" class="margin-left-10" v-model="orderNo"></el-input>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="search-view">
					<span style="padding-left: 30px;">商品名称:</span>
					<el-input size="mini" class="margin-left-10" v-model="courseName"></el-input>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="search-view">
					<span>会员名称:</span>
					<el-input size="mini" class="margin-left-10" v-model="memberName"></el-input>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="search-view">
					<el-button type="primary" size="mini" style="margin-left: 25px;" @click="shuaixuan">筛选</el-button>
					<el-button type="infor" size="mini" style="margin-left: 25px;" @click="daochu">导出报表</el-button>
					<el-button type="warning" size="mini" style="margin-left: 25px;" @click="zhikong">置空</el-button>
				</div>
			</el-col>
		</el-row>
		<el-table :data="tableData">
			<el-table-column label="序号" width="50px" prop="orderId"></el-table-column>
			<el-table-column label="单号" prop="orderNo" width="200px"></el-table-column>
			<el-table-column label="商品内容" prop="courseName"></el-table-column>
			<el-table-column label="课件方向" prop="courseDirectionName" width="200px"></el-table-column>
			<el-table-column label="课件分类" prop="courseCategoryName" width="200px"></el-table-column>
			<el-table-column label="下单用户" prop="memberName"></el-table-column>
			<el-table-column label="订单金额">
				<template slot-scope="scope">
					￥{{scope.row.totalPrice }}元
				</template>
			</el-table-column>
			<el-table-column label="优惠">
				<template slot-scope="scope">
					￥{{scope.row.discountPrice}}元
				</template>
			</el-table-column>
			<el-table-column label="应付金额">
				<template slot-scope="scope">
					<span style="color: red;">￥{{scope.row.payPrice}}元 </span>
				</template>
			</el-table-column>
			<el-table-column label="支付状态" prop="status">
				<template slot-scope="scope">
					<span v-if="scope.row.status == 0">待支付</span>
					<span style="color: #0081FF;" v-if="scope.row.status == 1">已支付</span>
					<span v-if="scope.row.status == 2">已完成</span>
					<span v-if="scope.row.status == 3">已取消</span>
					<span v-if="scope.row.status == 4">交易关闭</span>
				</template>

			</el-table-column>
			<el-table-column label="下单时间" prop="created" width="200px"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" style="color: #666666;" @click="chaKan(scope.row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				time: [],
				courseDirection: "",
				courseCategory: [],
				courseCategoryOne: "",
				courseCategoryTwo: "",
				startTime: "",
				endTime: "",
				orderNo: "",
				status: '',
				memberName: "",
				courseName: "",
				pageNum: 1,
				pageSize: 10,
				pagelist: [10, 50, 100],
				total: 0,
				options: [],
				options2: [],
				options3: [{
						value: '',
						label: "全部"
					},
					{
						value: 0,
						label: "待支付"
					},
					{
						value: 1,
						label: "已支付"
					},
					{
						value: 2,
						label: "已完成"
					},
					{
						value: 3,
						label: "已取消"
					},
					{
						value: 4,
						label: "交易关闭"
					},
				],
				tableData: [],
				cateListProps: {
					value: "dicId", //匹配响应数据中的id
					label: "dicDesc", //匹配响应数据中的name
					children: "sonDicList", //匹配响应数据中的children
				},
			}
		},
		methods: {
			chaKan(row) {
				console.log(row);
				this.$router.push({
					path: '/coursewareOrderdteails',
					query: {
						orderId: row.orderId
					}
				})
			},
			zhikong() {
				this.time = []
				this.courseCategory = []
				this.courseDirection = ''
				this.courseCategoryOne = ''
				this.courseCategoryTwo = ''
				this.startTime = ''
				this.endTime = ''
				this.orderNo = ''
				this.memberName = ''
				this.courseName = ''
				this.status = ''
				this.getInfo()
			},
			shuaixuan() {
				this.getInfo()
			},
			daochu() {
				if (this.courseCategory.length > 0) {
					this.courseCategoryOne = this.courseCategoryOne[0]
					this.courseCategoryTwo = this.courseCategoryOne[1]
				} else {
					this.courseCategoryOne = ""
					this.courseCategoryTwo = ""
				}
				this.$http.post("/api/clrorder/ClrOrdersController/exportExcel", {
					courseDirection: this.courseDirection,
					courseCategoryOne: this.courseCategory[0],
					courseCategoryTwo: this.courseCategory[1],
					startTime: "",
					endTime: "",
					orderNo: "",
					memberName: "",
					courseName: "",
					status: "",
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}, {
					responseType: 'blob'
				}).then(res => {
					this.$message({
						type: 'info',
						message: '正在导出课件订单表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '课件订单列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			getInfo() {
				console.log(this.courseCategory);
				if (this.courseCategory.length > 0) {
					this.courseCategoryOne = this.courseCategory[0]
					this.courseCategoryTwo = this.courseCategory[1]
				} else {
					this.courseCategoryOne = ""
					this.courseCategoryTwo = ""
				}
				if (this.time.length > 0) {
					this.startTime = this.time[0]
					this.endTime = this.time[1]
				} else {
					this.startTime = ""
					this.endTime = ""
				}
				this.$http.post("/api/clrorder/ClrOrdersController/clrOrderList", {
					courseDirection: this.courseDirection,
					courseCategoryOne: this.courseCategoryOne,
					courseCategoryTwo: this.courseCategoryTwo,
					startTime: this.startTime,
					endTime: this.endTime,
					orderNo: this.orderNo,
					memberName: this.memberName,
					courseName: this.courseName,
					status: this.status,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}).then(res => {
					console.log(res.data.data.list);
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			},
			//方向
			getInfo2() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=405`, {}).then(res => {
					// console.log(res.data.data, "方向");
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options.push({
								label: i.dicDesc,
								value: i.dicId
							})
						})
					}
				})
			},
			//类别
			getInfo3() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=82`, {}).then(
					res => {
						// console.log(res.data.data, "类别");
						if (res.data.data.length > 0) {
							res.data.data.forEach(i => {
								this.options2 = res.data.data
							})
						}
					})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
			this.getInfo2()
			this.getInfo3()
		}
	}
</script>

<style scoped>
	.margin-left-10 {
		margin-left: 10px;
	}
</style>
